// extracted by mini-css-extract-plugin
module.exports = {"terms":"nG","disabled":"oG","termsCheckbox":"pG","signUpButton":"qG","learnMoreButton":"rG"};